import { useState, useEffect, useContext, useCallback } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Modal, Table, Loader, Nav } from 'rsuite'
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import { FaRegPauseCircle } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import { FaPlayCircle } from "react-icons/fa";
import { BiSolidPhoneCall } from "react-icons/bi";
import { FaUserCheck } from "react-icons/fa";
import federalHolidays from '@18f/us-federal-holidays';
import Select from 'react-select'

import { checkIsAdmin, getAbbreviatedState } from '../../../services/helper'
import { getInCallsListSuppliers, getMasterCreatedFromCalls, getUnlinkedCalls, removeUnlinkedCallDetails, removeUnlinkedSupplierCallDetails, updateCallerForLsInSequence, getReenablementSuppliers, sendListSuppliersToCalls, getListSuppliersByIds } from '../../../redux/actions/caller'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import { getAllUsersInfo, getCallerUsers } from '../../../redux/actions/user'
import { checkIsAdminOrModerator } from '../../../services/helper'
import { toast } from '../../CommonComponents/ToastComponent/toast'
import LinkToVendorDetailsModal from './modals/linkToVendorDetailsModal'
import { getSuppliersDataByIds, pauseOrResumeSequencingToListId, stopOrResumeSequencing } from '../../../redux/actions/vendor'
import ContextMenu from '../../CommonComponents/ContextMenu'
import { getLastSentEmailDays, getRegisteredEmails, getUnreadEmailsCount } from '../../../redux/actions/emailSettings'
import { AppContext } from '../../../context'
import { getContacts, getContactsByIds } from '../../../redux/actions/contact'
import SendToCallsModal from './sendToCallsModal'

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, onClick, ...props }) => {
    return (
        <Cell {...props} role="button" className="table-link list-table-cell text-black" id={rowData.id} onClick={() => onClick(rowData.id)}>
            <button style={{ width: '60px' }} className={`h4 mb-0 text-start`}>
                {rowData[dataKey]}
            </button>
        </Cell>
    )
}

export const CallCell = ({ rowData, dataKey, onClick, qaLoader, callLoader, isAdmin, dispatch, getInSequenceSuppliersData, inCallsFilters, onRemoveCallerDetails, onEdit, onLinkToVendor, btnText, bgClass = '', customClass = '', isAdminOrMod, ...props }) => {
    const onPauseOrResumeSequencing = (listSupplierId, listId, operation, onlyUpdateSupplier) => {
        dispatch(pauseOrResumeSequencingToListId({ listSupplierId, listId, operation, onlyUpdateSupplier })).then(async () => {
            toast.show({
                title: 'Success',
                description: `Successfully ${operation === 'pauseSequence' ? 'Paused' : 'Resumed'}`,
            })
            await getInSequenceSuppliersData(inCallsFilters)
        }).catch(err => {
            toast.show({
                title: 'Danger',
                description: `Unable To ${operation === 'pauseSequence' ? 'Pause' : 'Resume'}`,
            })
        })
    }

    return (
        <Cell {...props} role="button" className="table-action" fixed>
            {btnText === 'Link to Vendor' ?
                <div className="table-action d-flex gap-2">
                    <div className="button ps-0 pe-0">
                        <button type="button" className={`h4 mb-0 bg-red text-white rounded pt-2 pb-2 p-4`} onClick={() => { onRemoveCallerDetails(rowData) }}>{'Remove Call Details'}</button>
                    </div>
                    <div className="button ps-0 pe-0">
                        <button type="button" className={`h4 mb-0 text-white rounded pt-2 pb-2 p-4 ${bgClass} ${customClass}`} onClick={() => { onLinkToVendor(rowData) }}>{btnText}</button>
                    </div>
                    <div className="button ps-0 pe-0">
                        <button type="button" className={`h4 mb-0 bg-blue text-white rounded pt-2 pb-2 p-4`} onClick={() => { onEdit(rowData) }}>{'Edit'}</button>
                    </div>
                </div>
                :
                <div className={isAdminOrMod ? "grid-container" : 'd-flex justify-content-center'} style={{ position: 'fixed', top: 5, columnGap: isAdminOrMod ? 0 : 10 }}>
                    <div className={isAdminOrMod ? 'column' : ''} style={{ alignSelf: 'center' }} >
                        <button type="button" class="btn rounded-circle position-relative p-0" style={{ backgroundColor: '#9e9e9e59', height: 35, width: 35 }}>
                            <i class="bi bi-envelope fs-2 text-black" ></i>
                            {rowData?.newMessage > 0 && <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                {rowData?.newMessage}
                            </span>}
                        </button>
                    </div>
                    <div className={isAdminOrMod ? 'column' : ''} style={{ alignSelf: 'center' }} >
                        {(isAdminOrMod && (rowData?.status?.toLowerCase() === 'in qa' || rowData?.status?.toLowerCase() === 'pending qa - stopped sequencing')) && (
                            <button title='QA' className={`rounded-circle p-2`} style={{ backgroundColor: qaLoader?.isLoading && qaLoader?.id === rowData?.id ? '' : '#2684ff' }} onClick={() => onClick(rowData?.id, rowData?.listId, 'qa')}>{qaLoader?.isLoading && qaLoader?.id === rowData?.id ? <Loader /> : <FaUserCheck color='#fff' size={22} />}</button>
                        )}
                    </div>
                    <div className={isAdminOrMod ? 'column' : ''} style={{ alignSelf: 'center' }} >
                        {((isAdminOrMod && rowData?.status?.toLowerCase() === 'in qa') || rowData?.status?.toLowerCase() === 'in calls' || rowData?.status?.toLowerCase() === 'pending qa - stopped sequencing') && (
                            <button title={rowData?.isPausedSequencing ? 'View' : 'Call'} className={`rounded-circle p-2`} style={{ backgroundColor: callLoader?.isLoading && callLoader?.id === rowData?.id ? '' : '#58CF6B' }} onClick={() => onClick(rowData?.id, rowData?.listId, 'call')}>{callLoader?.isLoading && callLoader?.id === rowData?.id ? <Loader /> : rowData?.isPausedSequencing ? <FaFileAlt size={22} color='#fff' /> : <BiSolidPhoneCall size={22} color='#fff' />}</button>
                        )}
                    </div>

                    {!rowData?.isStoppedSequencing && <div className={isAdminOrMod ? 'column' : ''} style={{ alignSelf: 'center' }}>
                        {isAdmin && <button className='rounded-circle p-2' title={rowData?.isPausedSequencing ? 'Resume' : 'Pause'} style={{ backgroundColor: rowData?.isPausedSequencing ? '' : '#2684FF', border: rowData?.isPausedSequencing ? '' : '' }} onClick={() => onPauseOrResumeSequencing(rowData?.id, rowData?.listId, rowData?.isPausedSequencing ? 'resumeSequence' : 'pauseSequence', true)}>{rowData?.isPausedSequencing ? <FaPlayCircle size={32} color='#2684FF' /> : <FaRegPauseCircle size={22} color='#FFF' />} </button>}
                    </div>}
                </div>
            }
        </Cell>
    )
}

export const TableCell = ({ unlinkedContactData, rowData, dataKey, onClick, users = [], ...props }) => {
    if (dataKey === 'state' && rowData[dataKey]) {
        rowData[dataKey] = getAbbreviatedState('', rowData[dataKey])
    }
    if (dataKey === 'partnerName') {
        rowData[dataKey] = rowData?.list?.partner?.partnerName || ''
    }
    if (dataKey === 'companyName') {
        rowData[dataKey] = rowData?.list?.[dataKey] || ''
    }
    if (dataKey === 'callerAssigned') {
        let callerName = users?.find((user) => user?.id === rowData?.vendorsInCall?.callerAssigned)
        rowData[dataKey] = callerName?.firstname + (callerName?.lastname ? ' ' + callerName?.lastname : '')
    }
    if (dataKey === 'caller') {
        let callerName = users?.find((user) => user?.id === rowData?.callerAssigned)
        rowData[dataKey] = callerName?.firstname + (callerName?.lastname ? ' ' + callerName?.lastname : '')
    }
    if (dataKey === 'status') {
        rowData[dataKey] = rowData?.vendorsInCall?.[dataKey]?.toString() || ''
    }

    if (dataKey === 'calls') {
        rowData[dataKey] = rowData?.vendorsInCall?.['callsAttempted']?.toString() || ''
    }

    if (dataKey === 'emails') {
        rowData[dataKey] = rowData?.totalOutboundEmails ? rowData?.totalOutboundEmails : 0
    }

    if (dataKey === 'lastCalledDate') {
        rowData[dataKey] = rowData?.vendorsInCall?.[dataKey] ? new Date(rowData?.vendorsInCall?.[dataKey]).toLocaleString() : ''
    }
    if (dataKey === 'timezone') {
        rowData[dataKey] = rowData['updatedTimeZone']?.toLocaleString()
    }
    if (dataKey === 'localTime') {
        rowData[dataKey] = rowData['localTime']?.toLocaleString()
    }
    if (dataKey === 'dateMovedToCalls') {
        let callMovedToCalls = new Date(rowData['vendorsInCall']?.dateMovedToCalls)
        let currentDate = new Date()

        let sequenceCount = 0
        while (callMovedToCalls < currentDate) {
            const holiday = federalHolidays.isAHoliday(callMovedToCalls);
            if (!holiday) {
                sequenceCount++
            }
            callMovedToCalls.setDate(callMovedToCalls.getDate() + 1);
        }
        rowData[dataKey] = sequenceCount
    }

    if (dataKey === 'dateWhenCalled') {
        rowData[dataKey] = rowData['vendorsInCall']?.dateMovedToCalls
    }

    if (dataKey === 'contactName') {
        const recording = rowData['callRecordings']?.[0];
        const contactId = recording?.contactName;

        if (contactId && /^\d+$/.test(contactId)) {
            const matchedContact = unlinkedContactData.find(contact => parseInt(contact.id) === parseInt(contactId));

            if (matchedContact) {
                const firstname = matchedContact.firstname || '';
                const lastname = matchedContact.lastname || '';
                rowData[dataKey] = `${firstname}${firstname && lastname ? ' ' : ''}${lastname}`;
            } else {
                rowData[dataKey] = recording?.externalNumber || '';
            }
        } else {
            rowData[dataKey] = recording?.externalNumber || '';
        }
    }

    if (dataKey === 'lastCalledDate') {
        let sequenceCount = 0;
        let lastEmailSentCount = 0;
        const lastCalledDate = rowData['vendorsInCall']?.lastCalledDate ? rowData['vendorsInCall']?.lastCalledDate : null
        const lastEmailSentDate = rowData?.lastEmailSentDate ? rowData?.lastEmailSentDate : null
        const currentDate = new Date();

        const calculateDaysDifference = (date) => {
            return date ? Math.floor((currentDate - new Date(date)) / (1000 * 60 * 60 * 24)) : 0;
        };

        sequenceCount = calculateDaysDifference(lastCalledDate);
        lastEmailSentCount = calculateDaysDifference(lastEmailSentDate);

        if (!lastCalledDate && !lastEmailSentDate) {
            rowData[dataKey] = 0
        } else if (lastCalledDate && lastEmailSentDate) {
            rowData[dataKey] = Math.min(sequenceCount, lastEmailSentCount);
        } else if (lastCalledDate && !lastEmailSentDate) {
            rowData[dataKey] = sequenceCount
        } else if (!lastCalledDate && lastEmailSentDate) {
            rowData[dataKey] = lastEmailSentCount
        }
    }

    if (dataKey === 'spend') {
        const spend = rowData?.[dataKey] ? '$ ' + rowData?.[dataKey] : ""
        return (
            <Cell {...props} className="table-link list-table-cell text-black" id={rowData.id}>
                {spend}
            </Cell>
        )
    }

    return (
        <Cell {...props} className="table-link list-table-cell text-black" id={rowData.id}>
            {dataKey === 'assumedVendorName' ? rowData[dataKey] || 'Unknown' : dataKey === "dateCalled" ? rowData?.callRecordings?.[0]?.dateCalled : rowData[dataKey]}
        </Cell>
    )
}

const SelectCell = ({ rowData, dispatch, getInSequenceSuppliersData, paginatedDataHandler, generalPage, reenablePage, generalLimit, reenableLimit, inCallsFilters, checkedKeys, callers, isAdminOrMod, isAdmin, dataKey, disabled, placeholder, options, columnValue, type, isDisabled, activeKey, inReenablementFilters, ...props }) => {
    const [selectedCaller, setSelectedCaller] = useState(rowData?.vendorsInCall?.callerAssigned)

    const onChangeCaller = async (e) => {
        if (activeKey === 'reenablement') {
            if (selectedCaller) {
                await dispatch(updateCallerForLsInSequence({ supplierId: rowData?.id, callerId: e?.value })).then(async (res) => {
                    toast.show({
                        title: 'Success',
                        description: 'Updated Caller SuccessFully',
                    })
                }).catch((err) => {
                    toast.show({
                        title: 'Danger',
                        description: 'Unable To Update Caller',
                    })
                })
            } else {
                let suppliersData = [{ listSupplierId: rowData?.id, callerAssigned: e?.value }]
                await dispatch(sendListSuppliersToCalls({
                    suppliersData: suppliersData, isReenablement: true
                }))
                    .then(async (res) => {
                        toast.show({
                            title: 'Success',
                            description: 'Updated Caller SuccessFully',
                        })
                    }).catch((err) => {
                        toast.show({
                            title: 'Danger',
                            description: 'Unable To Update Caller',
                        })
                    })
            }

            paginatedDataHandler(generalPage, reenablePage, generalLimit, reenableLimit, inReenablementFilters)
        } else {
            await dispatch(updateCallerForLsInSequence({ listSupplierId: rowData?.id, callerId: e?.value })).then(async (res) => {
                await getInSequenceSuppliersData(inCallsFilters)
                toast.show({
                    title: 'Success',
                    description: 'Updated Caller SuccessFully',
                })
            }).catch((err) => {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Update Caller',
                })
            })
        }
    }

    useEffect(() => {
        let assignedCaller = callers?.filter((caller) => caller?.value === rowData?.vendorsInCall?.callerAssigned)
        setSelectedCaller(assignedCaller[0])
    }, [])

    const value = callers?.find((caller) => caller?.value === rowData?.vendorsInCall?.callerAssigned)

    return <Cell {...props} className='selector-cell fw-normal d-flex align-items-center' style={{ display: 'flex', alignItems: 'center' }}>
        <Select
            isDisabled={!isAdminOrMod}
            placeholder={placeholder}
            options={callers}
            value={value}
            onChange={(item) => { onChangeCaller(item) }}
            menuPortalTarget={document.body}
            styles={{
                container: (baseStyles) => ({
                    ...baseStyles,
                    zIndex: 9999
                })
            }}
        />
    </Cell>
}

const InSequenceComponent = ({ tableData, isLoadingSequenceData, totalInCallsData, callsTableColumns, unlinkedVendorsTableColumns, onCallClick, onEditUnlinkedCalls, getInSequenceSuppliersData, inCallsFilters, currentTab, reenablementTableColumns, activeKey, setActiveKey, filterSelected, isFilterApplied, inReenablementFilters }) => {
    const reenablementTableColumnsWithCaller = [
        ...reenablementTableColumns,
        { name: 'callerAssigned', label: 'Assign To Caller' }
    ];
    const store = useStore().getState()
    const dispatch = useDispatch()
    const history = useHistory()
    const {
        user: {
            users,
            callerUsers
        },
        domain: {
            currentDomain,
        },
        auth: { user }
    } = store

    const {
        unreadEmails,
        parentEmailHistories,
        childEmailHistories,
        setParentEmailHistories,
        setChildEmailHistories,
        reauthenticateModal,
        setReauthenticateModal,
        emailsToReauthenticate,
        googleTokensValidationHandler,
        googleLogin,
        getSubscriptions
    } = useContext(AppContext);

    const isAdminOrMod = checkIsAdminOrModerator(currentDomain)
    const isAdmin = checkIsAdmin(currentDomain)
    const [isLoadingUnlinkedCalls, setIsLoadingUnlinkedCalls] = useState(false)
    const [callsTableData, setCallsTableData] = useState([])
    const [unlinkedCallsTableData, setUnlinkedCallsTableData] = useState([])
    const [unlinkedTotalData, setUnlinkedTotalData] = useState(0)
    const [unlinkedVendorsLimit, setUnlinkedVendorsLimit] = useState(10)
    const [unlinkedVendorsPage, setUnlinkedVendorsPage] = useState(1)
    const [showLinkToVendorModal, setShowLinkToVendorModal] = useState(false)
    const [showLinkToVendorDetailsModal, setShowLinkToVendorDetailsModal] = useState(false)
    const [showRemoveDetailsConfirmationModal, setShowRemoveDetailsConfirmationModal] = useState(false)
    const [vendorToLink, setVendorToLink] = useState(null)
    const [selectedCallDetail, setSelectedCallDetail] = useState({})
    const [qaLoader, setQALoader] = useState({ id: '', isLoading: false })
    const [callLoader, setCallLoader] = useState({ id: '', isLoading: false })
    const [callers, setCallers] = useState([])
    const [showContextMenu, setShowContextMenu] = useState(false)
    const [selectedListSupplier, setSelectedListSupplier] = useState({})
    const [showStopModal, setShowStopModal] = useState(false)
    const [collapsed, setCollapsed] = useState(true)
    const [stopSequencingNote, setStopSequencingNote] = useState('')
    const [sortColumn, setSortColumn] = useState(activeKey === "generalCalls" ? 'status_attempt' : 'suppliername');
    const [sortType, setSortType] = useState('asc');
    const [paginatedCallerIds, setPaginatedCallerIds] = useState([])
    const [paginatedContacts, setPaginatedContacts] = useState([])
    const [showSendToCallsModal, setShowSendToCallsModal] = useState(false)
    const [unlinkedContactData, setUnlinkedContactData] = useState([])
    let unlinkedVendorsPaginatedData = []

    const [inSequenceTableData, setInSequenceTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [paginatedData, setPaginatedData] = useState(0);
    const [emailGeneralPaginatedData, setEmailGeneralPaginatedData] = useState([])
    const [emailReenablementPaginatedData, setEmailReenablementPaginatedData] = useState([])
    const [generalPaginatedData, setGeneralPaginatedData] = useState([])
    const [reenablementPaginatedData, setReenablementPaginatedData] = useState([])
    const [generalPage, setGeneralPage] = useState(1)
    const [reenablePage, setReenablePage] = useState(1)
    const [generalLimit, setGeneralLimit] = useState(10)
    const [reenableLimit, setReenableLimit] = useState(10)
    const [total, setTotal] = useState(0);

    function parseLocalizedTime(localTime) {
        const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        if (!localTime) return { day: -1, time: 0 };

        const match = localTime.match(/(\d{1,2}):(\d{2})\s*(AM|PM)\s*,\s*(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)/i);
        if (!match) return { day: -1, time: 0 };

        const [_, hour, minute, period, dayName] = match;

        // Convert 12-hour format to 24-hour format for comparison
        let hourInt = parseInt(hour, 10);
        if (period.toUpperCase() === 'PM' && hourInt !== 12) {
            hourInt += 12; // Convert PM hours to 24-hour format
        } else if (period.toUpperCase() === 'AM' && hourInt === 12) {
            hourInt = 0; // Midnight handling
        }

        const dayIndex = daysOfWeek.indexOf(dayName);
        if (dayIndex === -1) return { day: -1, time: 0 }; // In case the day is not recognized

        const date = new Date();
        date.setHours(hourInt, parseInt(minute, 10), 0, 0); // Set hours and minutes
        return { day: dayIndex, time: date.getTime() }; // Return the day index and time for sorting
    }

    const getCallerName = (callerId) => {
        let name = callers.filter((caller) => {
            if (caller?.value === parseInt(callerId)) {
                return caller?.label
            }
        })
        return name[0]?.label
    }

    const onSortData = (column, direction, tableData) => {
        let data = []
        let tmpTableData = JSON?.parse(JSON?.stringify(tableData));

        if (direction === 'asc') {
            if (column === 'status_attempt') {
                data = tmpTableData?.sort((a, b) => {
                    const valA = a?.list?.partner?.partnerName?.toLowerCase() || "";
                    const valB = b?.list?.partner?.partnerName?.toLowerCase() || "";
                    if (valA !== valB) {
                        return valA.localeCompare(valB);
                    }

                    const companyA = a?.list?.companyName?.toLowerCase() || "";
                    const companyB = b?.list?.companyName?.toLowerCase() || "";
                    if (companyA !== companyB) {
                        return companyA.localeCompare(companyB);
                    }

                    const supplierA = a?.suppliername?.toLowerCase() || "";
                    const supplierB = b?.suppliername?.toLowerCase() || "";
                    if (supplierA !== supplierB) {
                        return supplierA.localeCompare(supplierB);
                    }


                    const statusA = a?.vendorsInCall?.status?.toLowerCase() || "";
                    const statusB = b?.vendorsInCall?.status?.toLowerCase() || "";
                    if (statusA !== statusB) {
                        return statusA.localeCompare(statusB);
                    }

                    let firstCaller = getCallerName(a?.vendorsInCall?.callerAssigned) || ""
                    let secondCaller = getCallerName(b?.vendorsInCall?.callerAssigned) || ""
                    if (firstCaller !== secondCaller) {
                        return firstCaller.localeCompare(secondCaller);
                    }

                    const dateA = new Date(a?.list?.dateSubmitted || 0);
                    const dateB = new Date(b?.list?.dateSubmitted || 0);
                    if (dateB - dateA !== 0) {
                        return dateB - dateA;
                    }

                    let lastActivityA = a?.vendorsInCall?.lastCalledDate
                    let lastActivityB = b?.vendorsInCall?.lastCalledDate

                    if (!lastActivityA) return 1
                    if (!lastActivityB) return 1
                    if (!lastActivityB && !lastActivityA) return 0

                    if (lastActivityB === lastActivityA) {
                        return new Date(lastActivityB) - new Date(lastActivityA)
                    }

                    const attemptsA = a?.vendorsInCall?.callsAttempted || 0;
                    const attemptsB = b?.vendorsInCall?.callsAttempted || 0;
                    if (attemptsA !== attemptsB) {
                        return attemptsA - attemptsB;
                    }

                    const timezoneA = a?.updatedTimeZone || '';
                    const timezoneB = b?.updatedTimeZone || '';
                    if (timezoneA !== timezoneB) {
                        return timezoneA.localeCompare(timezoneB);
                    }

                    const localTimeA = a?.localTime || "";
                    const localTimeB = b?.localTime || "";

                    const first = parseLocalizedTime(localTimeA);
                    const last = parseLocalizedTime(localTimeB);

                    if (last.day !== first.day) {
                        return last.day - first.day;
                    }

                    return last.time - first.time;
                });
            } else if (column === 'suppliername' || column === 'state' || column === 'timezone') {
                data = tmpTableData?.sort((a, b) => {
                    const valA = column === 'timezone' ? a?.updatedTimeZone || '' : a[column]?.toLowerCase() || "";
                    const valB = column === 'timezone' ? b?.updatedTimeZone || '' : b[column]?.toLowerCase() || "";
                    return valA.localeCompare(valB);
                });

            } else if (column === 'companyName' || column === 'dateSubmitted') {
                data = tmpTableData?.sort((a, b) => {
                    const valA = a?.list?.[column]?.toLowerCase() || "";
                    const valB = b?.list?.[column]?.toLowerCase() || "";
                    return valA.localeCompare(valB);
                });
            } else if (column === 'status') {
                data = tmpTableData?.sort((a, b) => {
                    const valA = a?.vendorsInCall[column]?.toLowerCase() || "";
                    const valB = b?.vendorsInCall[column]?.toLowerCase() || "";
                    return valB.localeCompare(valA);
                });
            } else if (column === 'emails') {
                data = tmpTableData.sort((a, b) => {
                    const emailCountA = a?.vendorsInCall?.['outboundEmailsCount'];
                    const emailCountB = b?.vendorsInCall?.['outboundEmailsCount'];
                    return emailCountA - emailCountB;
                });
            } else if (column === 'calls') {
                data = tmpTableData.sort((a, b) => {
                    const callA = a?.vendorsInCall?.['callsAttempted']
                    const callB = b?.vendorsInCall?.['callsAttempted']
                    return callA - callB;
                });
            } else if (column === 'localTime') {
                data = tmpTableData?.sort((a, b) => {
                    const localTimeA = a?.localTime || "";
                    const localTimeB = b?.localTime || "";

                    const first = parseLocalizedTime(localTimeA);
                    const last = parseLocalizedTime(localTimeB);

                    if (last.day !== first.day) {
                        return first.day - last.day;
                    }

                    return first.time - last.time;
                });
            } else if (column === 'dateMovedToCalls') {
                data = tmpTableData?.sort((a, b) => new Date(b?.['vendorsInCall']?.[column]) - new Date(a?.['vendorsInCall']?.[column]));
            } else if (column === 'lastCalledDate') {
                data = tmpTableData?.sort((a, b) => {
                    if (!a?.vendorsInCall?.lastCalledDate) return 1
                    if (!b?.vendorsInCall?.lastCalledDate) return 1
                    if (!b?.vendorsInCall?.lastCalledDate && !a?.vendorsInCall?.lastCalledDate) return 0

                    return new Date(b?.['vendorsInCall']?.[column]) - new Date(a?.['vendorsInCall']?.[column])
                });
            } else if (column === 'callerAssigned') {
                data = tmpTableData?.sort((a, b) => {
                    let firstCaller = getCallerName(a?.vendorsInCall?.callerAssigned) || ""
                    let secondCaller = getCallerName(b?.vendorsInCall?.callerAssigned) || ""

                    return firstCaller.localeCompare(secondCaller);
                });
            } else if (column === 'spend') {
                data = tmpTableData.sort((a, b) => {
                    const spendA = a?.spend || 0
                    const spendB = b?.spend || 0
                    return spendA - spendB;
                });
            }
        } else {
            if (column === 'suppliername' || column === 'state' || column === 'timezone') {
                data = tmpTableData?.sort((a, b) => {
                    const valA = column === 'timezone' ? a?.timezone || '' : a[column]?.toLowerCase() || "";
                    const valB = column === 'timezone' ? b?.timezone || '' : b[column]?.toLowerCase() || "";

                    return valB.localeCompare(valA);
                });

            } else if (column === 'companyName' || column === 'dateSubmitted') {
                data = tmpTableData?.sort((a, b) => {
                    const valA = a?.list?.[column]?.toLowerCase() || "";
                    const valB = b?.list?.[column]?.toLowerCase() || "";
                    return valB.localeCompare(valA);
                });

            } else if (column === 'status') {
                data = tmpTableData?.sort((a, b) => {
                    const valA = a?.vendorsInCall[column]?.toLowerCase() || "";
                    const valB = b?.vendorsInCall[column]?.toLowerCase() || "";
                    return valB.localeCompare(valA);
                });

            } if (column === 'emails') {
                data = tmpTableData.sort((a, b) => {
                    const emailCountA = a?.vendorsInCall?.['outboundEmailsCount'] || 0
                    const emailCountB = b?.vendorsInCall?.['outboundEmailsCount'] || 0
                    return emailCountB - emailCountA;
                });
            } else if (column === 'calls') {
                data = tmpTableData.sort((a, b) => {
                    const callsAttemptedA = a?.vendorsInCall?.['callsAttempted'] || 0
                    const callsAttemptedB = b?.vendorsInCall?.['callsAttempted'] || 0
                    return callsAttemptedB - callsAttemptedA;
                });
            } else if (column === 'localTime') {
                data = tmpTableData?.sort((a, b) => {
                    const localTimeA = a?.localTime || "";
                    const localTimeB = b?.localTime || "";

                    const first = parseLocalizedTime(localTimeA);
                    const last = parseLocalizedTime(localTimeB);

                    if (last.day !== first.day) {
                        return last.day - first.day;
                    }

                    return last.time - first.time;
                });
            }
            else if (column === 'dateMovedToCalls') {
                data = tmpTableData?.sort((a, b) => new Date(a?.['vendorsInCall']?.[column]) - new Date(b?.['vendorsInCall']?.[column]));
            } else if (column === 'lastCalledDate') {
                data = tmpTableData?.sort((a, b) => {
                    if (!a?.vendorsInCall?.lastCalledDate) return -1
                    if (!b?.vendorsInCall?.lastCalledDate) return -1
                    if (!b?.vendorsInCall?.lastCalledDate && !a?.vendorsInCall?.lastCalledDate) return 0

                    return new Date(b?.['vendorsInCall']?.[column]) - new Date(a?.['vendorsInCall']?.[column])
                });
            } else if (column === 'callerAssigned') {
                data = tmpTableData?.sort((a, b) => {
                    let firstCaller = getCallerName(a?.vendorsInCall?.callerAssigned) || ""
                    let secondCaller = getCallerName(b?.vendorsInCall?.callerAssigned) || ""
                    return secondCaller.localeCompare(firstCaller);
                });
            } else if (column === 'spend') {
                data = tmpTableData.sort((a, b) => {
                    const spendA = a?.spend || 0
                    const spendB = b?.spend || 0
                    return spendB - spendA;
                });
            }
        }

        return data
    }

    const handleSortColumn = (column, direction) => {
        setSortColumn(column);
        setSortType(direction);
    };

    const selectOptions = [
        { value: 'pause', label: 'Pause Sequencing' },
        { value: 'stop', label: 'Stop Sequencing' },
    ]

    const headerElements = (columns, type = 'calls') => {
        return columns.map((col, index) => {
            if (col?.name === "callerAssigned") {
                return (
                    <Column
                        resizable
                        width={190}
                        sortable={activeKey === 'reenablement' ? false : true}
                        key={col.name}
                    >
                        <HeaderCell className='fw-bold text-black' style={{ position: 'fixed' }}>{col.label}</HeaderCell>
                        <SelectCell
                            getInSequenceSuppliersData={getInSequenceSuppliersData}
                            paginatedDataHandler={paginatedDataHandler}
                            generalPage={generalPage}
                            reenablePage={reenablePage}
                            generalLimit={generalLimit}
                            reenableLimit={reenableLimit}
                            inCallsFilters={inCallsFilters}
                            dispatch={dispatch}
                            options={callers}
                            menuMaxHeight={200}
                            isAdminOrMod={isAdminOrMod}
                            callers={callers}
                            activeKey={activeKey}
                            dataKey={col.name}
                            inReenablementFilters={inReenablementFilters}
                        />
                    </Column>
                )
            } else if (type === 'unlinked') {
                return (
                    <Column
                        resizable
                        sortable={col?.hasOwnProperty('sortable') ? col?.sortable : true}
                        width={(index === 1) ? 200 : (index === 2 || index === 3 || index === 10) ? 80 : (index === 4 || index === 5 || index === 6 || index === 7 || index === 8 || index === 9) ? 100 : 140}
                        key={col.name}
                    >
                        <HeaderCell className='fw-bold text-black' style={{ position: 'fixed' }}>{col.label}</HeaderCell>
                        <TableCell className='text-black' dataKey={col.name} users={users} unlinkedContactData={unlinkedContactData} />
                    </Column>
                )
            } else {
                return (
                    <Column
                        resizable
                        sortable={col?.hasOwnProperty('sortable') ? col?.sortable : true}
                        width={(index === 1) ? 200 : (index === 2 || index === 3 || index === 10) ? 80 : (index === 4 || index === 5 || index === 6 || index === 7 || index === 8 || index === 9) ? 100 : 140}
                        key={col.name}
                    >
                        <HeaderCell className='fw-bold text-black '>{col.name === 'dateMovedToCalls' ? 'Days Since Submitted to Sequence' : col.name === 'lastCalledDate' ? 'Days Since Last Activity' : col.label}</HeaderCell>
                        <TableCell className='text-black' dataKey={col.name} users={users} />
                    </Column>
                )
            }
        })
    }

    const handleChangeLimit = (dataKey) => {
        setUnlinkedVendorsPage(1)
        setUnlinkedVendorsLimit(dataKey);
    }

    const handleCallClick = async (vendorId, listId, type = 'call') => {
        const vendorInCallData = activeKey === 'reenablement' ? reenablementPaginatedData?.find(data => data?.id === vendorId) : generalPaginatedData?.find(data => data?.id === vendorId)

        if (vendorInCallData?.matchedSupplierId) {
            type === 'call' ? setCallLoader({ id: vendorId, isLoading: true }) : setQALoader({ id: vendorId, isLoading: true })

            await dispatch(getSuppliersDataByIds([vendorInCallData?.matchedSupplierId])).then((masterSup) => {
                type === 'call' ? setCallLoader({ id: '', isLoading: false }) : setQALoader({ id: '', isLoading: false })
                const matchedSupplierId = masterSup[0]?.isMaster ? vendorInCallData?.matchedSupplierId : masterSup[0]?.masterId
                callClickHandler(vendorInCallData, type, listId, vendorId, matchedSupplierId)
            }).catch(err => {
                type === 'call' ? setCallLoader({ id: '', isLoading: false }) : setQALoader({ id: '', isLoading: false })
                toast.show({
                    title: 'Warning',
                    description: 'Failed to get Supplier Data'
                })
            })
        } else {
            callClickHandler(vendorInCallData, type, listId, vendorId, vendorInCallData?.matchedSupplierId)
        }
    }

    const callClickHandler = (vendorInCallData, type, listId, vendorId, matchedSupplierId) => {
        const vendorInCall = vendorInCallData?.vendorsInCall
        vendorInCall['partnerName'] = vendorInCallData?.partnerName
        vendorInCall['companyName'] = vendorInCallData?.companyName
        vendorInCall['nameUse'] = vendorInCallData?.list?.nameUse
        vendorInCall['contactName'] = vendorInCallData?.supplierDetail?.contactNameOld ? vendorInCallData?.supplierDetail?.contactNameOld : 'NONE'
        onCallClick(vendorId, listId, vendorInCall, type, matchedSupplierId)
    }

    const handleEditClick = (callData) => {
        onEditUnlinkedCalls(callData)
        setSelectedCallDetail(callData)
    }

    const handleLinkToVendorClick = (callData) => {
        setShowLinkToVendorModal(true)
        dispatch(getInCallsListSuppliers({}, !isAdminOrMod ? user?.id : '')).then(result => {
            setCallsTableData(result)
        }).catch(() => {
            setCallsTableData([])
        })
        setSelectedCallDetail(callData)
    }


    const handleRemoveCallerDetailsClick = (callData) => {
        setShowRemoveDetailsConfirmationModal(true)
        setSelectedCallDetail(callData)
    }

    const onChangeLinkToVendor = (vendorId) => {
        setVendorToLink(vendorId)
    }

    const handleClose = async (type = null) => {
        setShowLinkToVendorModal(false)
        setVendorToLink(null)
        setSelectedCallDetail({})
        if (type === 'complete') {
            setIsLoadingUnlinkedCalls(true)
            await dispatch(getInCallsListSuppliers({}, !isAdminOrMod ? user?.id : '')).then(result => {
                setCallsTableData(result)
            }).catch(() => {
                setCallsTableData([])
                setIsLoadingUnlinkedCalls(false)
            })
            await dispatch(getUnlinkedCalls(!isAdminOrMod ? user?.id : '')).then(result => {
                setUnlinkedCallsTableData(result)
                setUnlinkedTotalData(result?.length)
                setIsLoadingUnlinkedCalls(false)
            }).catch(() => {
                setUnlinkedCallsTableData([])
                setUnlinkedTotalData(0)
                setIsLoadingUnlinkedCalls(false)
            })
        }
    }

    const handleOkClick = () => {
        if (!vendorToLink) {
            toast.show({
                title: 'Warning',
                description: 'Please select supplier to link!'
            })
            return
        }
        setShowLinkToVendorDetailsModal(true)
    }

    const handleRemoveOkClick = async () => {
        setIsLoadingUnlinkedCalls(true)
        dispatch(removeUnlinkedCallDetails(selectedCallDetail?.vendorsInCall?.id, selectedCallDetail?.id)).then(async (res) => {
            await dispatch(removeUnlinkedSupplierCallDetails(selectedCallDetail?.id, true))
            dispatch(getUnlinkedCalls(!isAdminOrMod ? user?.id : '')).then(result => {
                setUnlinkedCallsTableData(result)
                setUnlinkedTotalData(result?.length)
            }).catch(() => {
                setIsLoadingUnlinkedCalls(false)
                setUnlinkedCallsTableData([])
            })
            toast.show({
                title: 'Success',
                description: res?.message
            })
            setIsLoadingUnlinkedCalls(false)
            handleRemoveCancelClick()
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: err?.message,
            })
            setIsLoadingUnlinkedCalls(false)
        })
    }

    const handleRemoveCancelClick = () => {
        setShowRemoveDetailsConfirmationModal(false)
        setSelectedCallDetail({})
    }

    const handleVendorDetailsClose = (type = '') => {
        setShowLinkToVendorDetailsModal(false)
        if (type === 'complete') {
            handleClose('complete')
        }
    }

    const stopOrResumeSequencingHandler = async (operation) => {
        await dispatch(stopOrResumeSequencing({ listSupplierId: selectedListSupplier?.id, note: stopSequencingNote, operation: operation })).then(async () => {
            toast.show({
                title: 'Success',
                description: `${operation === 'resume' ? 'Resumed' : 'Paused'} Successfully`,
            })
            await getInSequenceSuppliersData(inCallsFilters)
        }).catch(err => {
            toast.show({
                title: 'Danger',
                description: `Unable To ${operation === 'resume' ? 'Resumed' : 'Paused'}`,
            })
        })
    }

    const onMenuItemClick = (option) => {
        if (option?.value === 'pause' || option?.value === 'unpause') {
            dispatch(pauseOrResumeSequencingToListId({ listSupplierId: selectedListSupplier?.id, listId: selectedListSupplier?.listId, operation: option?.value === 'pause' ? 'pauseSequence' : 'resumeSequence', onlyUpdateSupplier: true })).then(async () => {
                toast.show({
                    title: 'Success',
                    description: `Successfully ${option?.value === 'pause' ? 'Paused' : 'Resumed'}`,
                })
                await getInSequenceSuppliersData(inCallsFilters)
            }).catch(err => {
                toast.show({
                    title: 'Danger',
                    description: `Unable To ${option?.value === 'pause' ? 'Pause' : 'Resume'}`,
                })
            })
        } else if (option?.value === 'stop') {
            setShowStopModal(true)
            setCollapsed(true)
            setStopSequencingNote('')
        } else if (option?.value === "resume") {
            stopOrResumeSequencingHandler('resume')
        }
    }

    const showContextMenuItems = () => {
        if (!isAdmin) {
            return
        }
        let listTable = document.getElementById('calls-table')
        if (listTable) {
            listTable.oncontextmenu = function (e) {
                e.preventDefault()
                const parentWithClass = e.target.closest('.rs-table-row .list-table-cell');
                const rowId = parseInt(parentWithClass.id)
                const rowData = generalPaginatedData.find((list) => list?.id === rowId)

                setShowContextMenu(true)
                setSelectedListSupplier(rowData)
            }
        }
    }

    const onStopOrResumeSequencing = async () => {
        await stopOrResumeSequencingHandler('stop')
        setShowStopModal(false)
        setCollapsed(true)
        setStopSequencingNote('')
    }

    const getUnreadEmailsOnNotification = async () => {
        let listSupplierIds = []
        let result = []
        let sequenceData = activeKey === 'reenablement' ? JSON.parse(JSON.stringify(reenablementPaginatedData)) : JSON.parse(JSON.stringify(generalPaginatedData))

        if (activeKey !== 'reenablement') {
            listSupplierIds = generalPaginatedData?.map(data => data?.id)
            result = await dispatch(getLastSentEmailDays(listSupplierIds)).then((res) => res).catch(err => { if (err) { return 0 } })
        }

        const updatedSortedData = sequenceData?.map((sequenceRow) => {
            let count = 0
            let ls

            if (activeKey !== 'reenablement') {
                ls = result?.count?.filter((listSup) => listSup?.listSupplierId === sequenceRow?.id)
                if (ls?.length > 0) {
                    sequenceRow['EmaillastActivity'] = ls?.[0]?.daysSinceLastSent
                }
            }

            for (let index = 0; index < sequenceRow?.contacts?.length; index++) {
                const contact = sequenceRow?.contacts[index];
                for (let index = 0; index < [...unreadEmails]?.length; index++) {
                    const unreadEmail = [...unreadEmails][index]
                    if (unreadEmail?.senderEmail?.toLowerCase() === contact?.email?.toLowerCase()) {
                        ++count
                    }
                }
            }
            return count > 0 ? { ...sequenceRow, newMessage: sequenceRow?.newMessage + count } : sequenceRow;
        })

        const validParentEmailHistories = parentEmailHistories?.filter((emailHistory) => {
            return paginatedContacts?.contacts?.filter(contact =>
                contact?.email?.toLowerCase() === emailHistory?.senderEmail?.toLowerCase()
            );
        });

        const validChildEmailHistories = childEmailHistories?.filter((emailHistory) => {
            return paginatedContacts?.contacts?.filter(contact =>
                contact?.email?.toLowerCase() === emailHistory?.senderEmail?.toLowerCase()
            );
        });

        setParentEmailHistories(validParentEmailHistories)
        setChildEmailHistories(validChildEmailHistories)
        if (activeKey !== 'reenablement') {
            setGeneralPaginatedData(prevSortedData => JSON?.stringify(prevSortedData) !== JSON?.stringify(updatedSortedData) ? updatedSortedData : prevSortedData);
        } else {
            setReenablementPaginatedData(prevSortedData => JSON?.stringify(prevSortedData) !== JSON?.stringify(updatedSortedData) ? updatedSortedData : prevSortedData)
        }
    }

    const reauthenticateHandler = async () => {
        await googleLogin(true, null, [], [], null, [], 'sequence', () => {
            setReauthenticateModal(false)
            paginatedDataHandler(generalPage, reenablePage, generalLimit, reenableLimit, inReenablementFilters)
        })
    }

    if (!isAdminOrMod) {
        unlinkedVendorsPaginatedData = unlinkedCallsTableData?.sort((a, b) => new Date(b?.callRecordings?.[0]?.dateCalled) - new Date(a?.callRecordings?.[0]?.dateCalled)).slice(unlinkedVendorsLimit * (unlinkedVendorsPage - 1), unlinkedVendorsLimit * unlinkedVendorsPage)
    } else {
        unlinkedVendorsPaginatedData = unlinkedCallsTableData?.slice(unlinkedVendorsLimit * (unlinkedVendorsPage - 1), unlinkedVendorsLimit * unlinkedVendorsPage)
    }

    const handelcallerModal = () => {
        setShowSendToCallsModal(true);
    };

    const onSendToCallsModalClose = (isRefreshListsData = false) => {
        setShowSendToCallsModal(false)
    }

    const onTabChange = (key) => {
        setActiveKey(key)
        if (key === 'reenablement') {
            setSortColumn('suppliername')
            setGeneralPage(1)
        } else {
            setSortColumn('status_attempt')
            setReenablePage(1)
        }
        setPaginatedCallerIds([])
        setPaginatedContacts([])
        setSortType('asc')
    }

    const getReenablementSuppliersData = async (limit = 10, offset = 0, sortColumn, inReenablementFilters = {}) => {
        let tmpReenableSuppliers = []
        let totalReenablementData = 0
        await dispatch(getReenablementSuppliers({ limit, offset, sortColumn, sortType, isShowAllSuppliers: true, 'filterData': inReenablementFilters }))
            .then(result => {
                tmpReenableSuppliers = result?.reenablementSuppliers
                totalReenablementData = result?.total
            })
            .catch((err) => {
                toast.show({
                    title: 'Danger',
                    description: `Unable to fetch the suppliers for reenablement`,
                });
            });

        return {
            tmpReenableSuppliers,
            totalReenablementData
        }
    }

    const addEmailCountToPaginatedDataHandler = useCallback(async () => {
        let finalSequenceData = []
        let countResult

        let allTmpRegisteredEmails = await dispatch(getRegisteredEmails(paginatedCallerIds)).then(res => res).catch((err) => { if (err) { return [] } })
        let sequenceData = activeKey === 'reenablement' ? JSON.parse(JSON.stringify(emailReenablementPaginatedData)) : JSON.parse(JSON.stringify(emailGeneralPaginatedData))

        for (let firstIndex = 0; firstIndex < sequenceData?.length; firstIndex++) {
            const sortedData = sequenceData[firstIndex];
            let count = 0;
            let tmpRegisteredEmails = allTmpRegisteredEmails?.filter((registeredEmails) => registeredEmails?.userId === sortedData?.vendorsInCall?.callerAssigned)
            for (let index = 0; index < tmpRegisteredEmails.length; index++) {
                const tmpRegisteredEmail = tmpRegisteredEmails[index];
                let oneConnectionCount = 0
                for (let secondIndex = 0; secondIndex < sortedData?.contacts?.length; secondIndex++) {
                    const contact = sortedData?.contacts[secondIndex];
                    if (contact?.email) {
                        countResult = await dispatch(getUnreadEmailsCount(
                            tmpRegisteredEmail?.domain,
                            tmpRegisteredEmail?.email,
                            contact?.email,
                            tmpRegisteredEmail?.accessToken,
                            tmpRegisteredEmail?.domain === 'google' ? tmpRegisteredEmail?.refreshToken : null
                        )).then(res => res).catch(err => { if (err) { return 0 } })
                    }

                    oneConnectionCount += countResult?.count
                }
                count += oneConnectionCount
            }

            if (count > 0) {
                sortedData['newMessage'] = count
            }

            finalSequenceData?.push(sortedData)
        }
        activeKey === 'reenablement' ? setReenablementPaginatedData(finalSequenceData) : setGeneralPaginatedData(finalSequenceData);
        setIsLoading(false)
    }, [emailGeneralPaginatedData, emailReenablementPaginatedData, paginatedCallerIds])

    const addContactsToPaginatedDataHandler = useCallback(async () => {
        let listSupplierIds = []
        let result = []
        let matchedMasterIds = []
        let contacts = []
        let lsIdsWithNoMaster = []
        let masterCreatedFromCalls = []
        let masterIds = []
        let tmpPaginatedCallerIds = []

        if (activeKey !== 'reenablement') {
            listSupplierIds = paginatedData?.map(data => data?.id)
            result = await dispatch(getLastSentEmailDays(listSupplierIds)).then((res) => res).catch(err => { if (err) { return 0 } })
            matchedMasterIds = paginatedData?.map(data => data?.matchedMasterSupplierId)?.filter(data => data)
            lsIdsWithNoMaster = paginatedData?.map((listSupplier) => {
                if (!listSupplier?.matchedSupplierId && Object.keys(listSupplier?.masterData || {}).length === 0
                ) {
                    return listSupplier?.id
                } else {
                    return null
                }
            }).filter((data) => data !== null)

            masterCreatedFromCalls = await dispatch(getMasterCreatedFromCalls(lsIdsWithNoMaster)).then((res) => res).catch((err) => { if (err) { return [] } })
            masterIds = masterCreatedFromCalls?.masters?.map(data => data?.id)
            if (masterIds?.length || matchedMasterIds?.length || listSupplierIds?.length) {
                contacts = await dispatch(getContacts({ supplierIds: [...masterIds, ...matchedMasterIds], supType: null, listSupplierId: null, vendorInCallDetailsId: null, listSupplierIds: listSupplierIds, isGetForEmailHistory: true })).then((res) => res).catch(err => { if (err) { return [] } })
            }
        } else {
            masterIds = paginatedData?.map((paginatedRow) => paginatedRow?.id)
            if (masterIds?.length > 0) {
                contacts = await dispatch(getContacts({ supplierIds: [...masterIds], supType: null, listSupplierId: null, vendorInCallDetailsId: null, listSupplierIds: [], isGetForEmailHistory: true })).then((res) => res).catch(err => { if (err) { return [] } })
            }
        }

        let updatedPaginatedData = paginatedData?.map((supplier) => {
            let tmpContact
            let masterCreatedFromCallsData = []

            if (activeKey !== 'reenablement') {
                masterCreatedFromCallsData = masterCreatedFromCalls?.masters?.find((master) => master?.listSupplierId === supplier?.id)
                supplier['masterFromCalls'] = masterCreatedFromCallsData?.id ? masterCreatedFromCallsData : {}

                if (supplier?.masterData?.id) {
                    tmpContact = contacts?.contacts?.filter((contact) => contact?.supplierId?.includes(supplier?.masterData?.id))
                } else if (supplier?.masterFromCalls?.id) {
                    tmpContact = contacts?.contacts?.filter((contact) => contact?.supplierId?.includes(supplier?.masterFromCalls?.id))
                } else {
                    tmpContact = contacts?.contacts?.filter((contact) => contact?.listSupplierId?.includes(supplier?.id))
                }

                for (let index = 0; index < result?.count?.length; index++) {
                    const resultObj = result?.count?.[index];
                    if (supplier?.id === resultObj?.supplierId) {
                        supplier['lastEmailSentDate'] = resultObj?.lastSentDate
                    }
                }
            } else {
                tmpContact = contacts?.contacts?.filter((contact) => contact?.supplierId?.includes(supplier?.id))
                tmpPaginatedCallerIds.push(supplier?.vendorsInCall?.callerAssigned)
            }

            supplier['contacts'] = tmpContact?.length === 0 ? [] : tmpContact
            return supplier
        })

        activeKey !== 'reenablement' ? setEmailGeneralPaginatedData(updatedPaginatedData) : setEmailReenablementPaginatedData(updatedPaginatedData)
        setPaginatedContacts(contacts)
    }, [paginatedData])

    const paginatedDataHandler = useCallback(async (generalPage, reenablePage, generalLimit, reenableLimit, inReenablementFilters) => {
        let tmpPaginatedData = []
        let tmpPaginatedCallersIds = []
        let totalData = 0
        setIsLoading(true)
        if (activeKey === 'generalCalls') {
            let tmpSortData = onSortData(sortColumn, sortType, tableData)
            tmpPaginatedData = tmpSortData?.slice(generalLimit * (generalPage - 1), generalLimit * generalPage);
            let filteredListSupplierId = tmpPaginatedData?.map(data => data?.listSupplierId)
            await dispatch(getListSuppliersByIds(filteredListSupplierId))
                .then((res) => {
                    const responseMap = new Map(res.listSupplier.map(item => [item.id, item]))
                    tmpPaginatedData = tmpPaginatedData.map(item => {
                        const matching = responseMap.get(item.listSupplierId)
                        if (matching) {
                            Object.keys(matching).forEach(key => {
                                if (!(key in item)) {
                                    item[key] = matching[key]
                                }
                            })
                        }
                        return item
                    })
                })
                .catch(err => {
                    if (err) {
                        return 0
                    }
                })
            totalData = tableData?.length
        } else if (activeKey === 'reenablement') {
            const offset = (reenablePage - 1) * reenableLimit;
            let { tmpReenableSuppliers, totalReenablementData } = await getReenablementSuppliersData(reenableLimit, offset, sortColumn, inReenablementFilters)
            tmpPaginatedData = JSON.parse(JSON.stringify(tmpReenableSuppliers))
            totalData = totalReenablementData
        }

        if (user?.roleName === 'admin') {
            tmpPaginatedCallersIds = Array.from(new Set(tmpPaginatedData?.map((sequenceData) => sequenceData?.vendorsInCall?.callerAssigned))).filter((callerId) => callerId !== undefined)
        } else {
            tmpPaginatedCallersIds = [user?.id]
        }

        setPaginatedData(tmpPaginatedData)
        setTotal(totalData)
        setPaginatedCallerIds(tmpPaginatedCallersIds)
    }, [activeKey, tableData, inReenablementFilters, isFilterApplied, sortColumn])

    const generalPaginationHandler = (page) => {
        setGeneralPage(page)
    }

    const reenablementPaginationHandler = (page) => {
        setReenablePage(page)
    }

    const generalLimitHandler = (limit) => {
        setGeneralLimit(limit)
        setGeneralPage(1)
    }

    const reenableLimitHandler = (limit) => {
        setReenableLimit(limit)
        setReenablePage(1)
    }

    useEffect(() => {
        if (isLoadingSequenceData) {
            setIsLoading(true)
        }
    }, [isLoadingSequenceData])

    useEffect(() => {
        if (tableData?.length > 0) {
            activeKey === "reenablement" ? setReenablePage(1) : setGeneralPage(1)
            setInSequenceTableData(tableData)
        }
    }, [tableData])

    useEffect(() => {
        if (inSequenceTableData?.length > 0 || activeKey === 'reenablement') {
            paginatedDataHandler(generalPage, reenablePage, generalLimit, reenableLimit, inReenablementFilters)
        }
    }, [inSequenceTableData, activeKey, generalPage, reenablePage, generalLimit, reenableLimit])

    useEffect(() => {
        if (activeKey === 'reenablement' && Object.values(inReenablementFilters)?.length > 0) {
            setReenablePage(1)
        }
    }, [isFilterApplied])

    useEffect(() => {
        if (paginatedData?.length > 0) {
            addContactsToPaginatedDataHandler()
        }
    }, [paginatedData])

    useEffect(() => {
        if (emailGeneralPaginatedData?.length > 0 || emailReenablementPaginatedData?.length > 0) {
            addEmailCountToPaginatedDataHandler()
        }
    }, [emailGeneralPaginatedData, emailReenablementPaginatedData])


    useEffect(() => {
        if (unreadEmails?.length > 0)
            getUnreadEmailsOnNotification()
    }, [unreadEmails])

    useEffect(() => {
        let tmpCallers = callerUsers?.map((caller) => {
            return {
                label: caller?.firstname + " " + caller?.lastname,
                name: caller?.id,
                value: caller?.id
            }
        })
        googleTokensValidationHandler([user?.id])
        getSubscriptions()
        setCallers(tmpCallers)
    }, [])

    useEffect(() => {
        showContextMenuItems()
    })

    useEffect(() => {
        history.push('/lists/insequence')
        setIsLoadingUnlinkedCalls(true)
        dispatch(getUnlinkedCalls(!isAdminOrMod ? user?.id : ''))
            .then(async result => {
                if (result?.length === 0) {
                    setUnlinkedCallsTableData([]);
                    setUnlinkedTotalData(0);
                    setIsLoadingUnlinkedCalls(false);
                } else {
                    const allContactIds = [];
                    result?.forEach(call => {
                        call?.callRecordings?.forEach(recording => {
                            const name = recording?.contactName?.trim();
                            if (name && /^\d+$/.test(name)) {
                                allContactIds.push(Number(name));
                            }
                        });
                    });
                    const uniqueContactIds = [...new Set(allContactIds)];
                    if (uniqueContactIds?.length === 0) {
                        setUnlinkedContactData([])
                    } else {
                        try {
                            const contactsData = await dispatch(getContactsByIds({ contactIds: uniqueContactIds }));
                            setUnlinkedContactData(contactsData)
                        } catch (err) {
                            toast.show({
                                title: 'Danger',
                                description: 'Failed to fetch contacts by IDs'
                            })
                        }
                    }

                    setUnlinkedCallsTableData(result);
                    setUnlinkedTotalData(result?.length);
                    setIsLoadingUnlinkedCalls(false);
                }
            })
            .catch(() => {
                setUnlinkedCallsTableData([]);
                setUnlinkedTotalData(0);
                setIsLoadingUnlinkedCalls(false);
            });
        if (!users || users.length === 0) {
            dispatch(getAllUsersInfo())
        }

        dispatch(getCallerUsers())
        setSelectedCallDetail({})
    }, [])

    return (
        <div className='mt-5 mb-4'>
            <div className='d-flex justify-content-between'>
                <div className='d-flex column-gap-4'>
                    <button
                        className=' rounded-top fw-bold border'
                        style={{ backgroundColor: activeKey !== 'generalCalls' ? 'white' : '#214466', color: activeKey !== 'generalCalls' ? 'black' : 'white', width: 160, height: 40, fontSize: 16 }}
                        onClick={() => { onTabChange('generalCalls') }}
                    >Imported Suppliers
                    </button>
                    <button
                        className='rounded-top fw-bold border'
                        style={{ backgroundColor: activeKey !== 'reenablement' ? 'white' : '#214466', color: activeKey !== 'reenablement' ? 'black' : 'white', width: 160, height: 40, fontSize: 16 }}
                        onClick={() => { onTabChange('reenablement') }}
                    >
                        Reenablement
                    </button>
                </div>
                {activeKey === 'reenablement' && <div>
                    <button className='ms-auto p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end bg-green' onClick={handelcallerModal}> Assign Caller </button>
                </div>}
            </div>
            <div>

            </div>
            <div>
                {activeKey === 'generalCalls' &&
                    <div>
                        <div className='imported-vendors-table sequence-table'>
                            {reauthenticateModal && emailsToReauthenticate && <Modal backdrop={true} className="" onHide={() => { setReauthenticateModal(false) }} show={reauthenticateModal} size="sm">
                                <Modal.Header>
                                    <h3 className="mb-0 fw-bold">Tokens Expired</h3>
                                </Modal.Header>
                                <Modal.Body className='p-0'>
                                    <h4 className='p-0'>Your tokens are expired for <span className='fw-bold'>{emailsToReauthenticate}</span></h4>
                                    <p className='fs-4 p-0'>Please re-authenticate again</p>
                                </Modal.Body>
                                <Modal.Footer >
                                    <button className='report_button_secondary' onClick={reauthenticateHandler}>OK</button>
                                </Modal.Footer>
                            </Modal>}

                            {showStopModal && (
                                <Modal
                                    backdrop={'static'}
                                    className="link-to-vendor-modal"
                                    show={showStopModal}
                                    size="lg"
                                    onHide={() => { setShowStopModal(false); setStopSequencingNote('') }}
                                >
                                    <Modal.Header>
                                        <Modal.Title className='text-black fw-bold text-wrap'>
                                            You have selected to force stop enablement for this supplier. The supplier will automatically be sent to QA with the acceptance details that are currently gathered. Are you sure you want to stop the enablement campaign?
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className='mt-4 h-75'>
                                        <div className=' border rounded' style={{ height: collapsed ? 52.5 : 180 }}>
                                            <div className=' d-flex justify-content-between p-4'>
                                                <p className='fw-bold fs-4 m-0' style={{ color: '#214466' }}>Add Note:</p>
                                                {collapsed && <button onClick={() => { setCollapsed(false) }}><FaPlus color='#214466' size={20} /></button>}
                                                {!collapsed && <button onClick={() => { setCollapsed(true) }}><FaMinus color='#214466' size={20} /></button>}
                                            </div>
                                            {!collapsed && <div className='p-4'>
                                                <textarea className='form-control fs-4' style={{ height: 100 }} value={stopSequencingNote} onChange={(e) => { setStopSequencingNote(e.target.value) }} />
                                            </div>}
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button
                                            type="button"
                                            className="me-3 h4 mb-0 pt-2 pb-2 bg-gray text-white width-100 rounded"
                                            onClick={() => { setShowStopModal(false); setStopSequencingNote('') }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="h4 mb-0 pt-2 pb-2 btn-green width-100 rounded"
                                            onClick={() => { onStopOrResumeSequencing('stop') }}
                                        >
                                            Confirm
                                        </button>
                                    </Modal.Footer>
                                </Modal>
                            )}
                            <div className={`mt-4 border border-2 rounded position-relative`}>
                                <Table
                                    virtualized={true}
                                    affixHeader={true}
                                    height={500}
                                    data={generalPaginatedData}
                                    className='calls-table'
                                    id='calls-table'
                                    rowKey="id"
                                    sortType={sortType}
                                    sortColumn={sortColumn}
                                    loading={isLoading}
                                    onSortColumn={handleSortColumn}
                                >
                                    {headerElements(callsTableColumns)}
                                    <Column fixed="right" dataKey='call' key="action" width={isAdminOrMod ? 280 : 200}>
                                        <HeaderCell className='fw-bold text-black' align={isAdminOrMod ? 'center' : ''}>Action</HeaderCell>
                                        <CallCell
                                            onClick={handleCallClick}
                                            qaLoader={qaLoader}
                                            callLoader={callLoader}
                                            btnText='Call'
                                            bgClass='bg-green'
                                            customClass='p-5'
                                            isAdminOrMod={isAdminOrMod}
                                            isAdmin={isAdmin}
                                            dispatch={dispatch}
                                            getInSequenceSuppliersData={getInSequenceSuppliersData}
                                            inCallsFilters={inCallsFilters} />
                                    </Column>
                                </Table>

                                <div className="calls-table-pagination">
                                    <Pagination
                                        prev
                                        next
                                        first={true}
                                        last={true}
                                        maxButtons={5}
                                        activePage={generalPage}
                                        showInfo
                                        displayLength={generalLimit}
                                        lengthMenu={[
                                            {
                                                label: '10',
                                                value: 10,
                                            },
                                            {
                                                label: '20',
                                                value: 20,
                                            },
                                            {
                                                label: '30',
                                                value: 30,
                                            },
                                            {
                                                label: '50',
                                                value: 50,
                                            },
                                            {
                                                label: '100',
                                                value: 100,
                                            },
                                        ]}
                                        total={total}
                                        onChangeLength={(limit) => { generalLimitHandler(limit) }}
                                        onChangePage={(event) => { generalPaginationHandler(event) }}
                                    />
                                </div>
                            </div>
                            {showContextMenu && (
                                <ContextMenu menuItems={selectOptions} onMenuItemClick={onMenuItemClick} onMenuItemBlur={() => { setShowContextMenu(false) }} selectedLs={selectedListSupplier} />
                            )}
                        </div>

                        <div className='imported-vendors-table mt-5'>
                            <h1 className='mb-4 text-black fw-bold'>Unlinked Calls</h1>
                            <div className={`mt-4 border border-2 rounded position-relative${isLoadingUnlinkedCalls ? ' loading' : ''}`}>
                                <Table
                                    virtualized={true}
                                    affixHeader={true}
                                    height={500}
                                    data={unlinkedVendorsPaginatedData}
                                    loading={isLoadingUnlinkedCalls}
                                    className='calls-table'
                                    id='calls-table'
                                    rowKey="id"
                                >
                                    {headerElements(unlinkedVendorsTableColumns, 'unlinked')}
                                    <Column fixed="right" dataKey='linkToVendor' key="action" width={400}>
                                        <HeaderCell className='fw-bold text-black'>Action</HeaderCell>
                                        <CallCell
                                            btnText='Link to Vendor'
                                            bgClass='bg-green'
                                            onRemoveCallerDetails={handleRemoveCallerDetailsClick}
                                            onEdit={handleEditClick}
                                            onLinkToVendor={handleLinkToVendorClick}
                                        />
                                    </Column>
                                </Table>
                                <div className="calls-table-pagination">
                                    <Pagination
                                        prev
                                        next
                                        first={true}
                                        last={true}
                                        maxButtons={5}
                                        activePage={unlinkedVendorsPage}
                                        showInfo
                                        displayLength={unlinkedVendorsLimit}
                                        lengthMenu={[
                                            {
                                                label: '10',
                                                value: 10,
                                            },
                                            {
                                                label: '20',
                                                value: 20,
                                            },
                                            {
                                                label: '30',
                                                value: 30,
                                            },
                                            {
                                                label: '50',
                                                value: 50,
                                            },
                                            {
                                                label: '100',
                                                value: 100,
                                            },
                                        ]}
                                        total={unlinkedTotalData}
                                        onChangeLength={(limit) => { handleChangeLimit(limit) }}
                                        onChangePage={(event) => { setUnlinkedVendorsPage(event) }}
                                    />
                                </div>
                            </div>
                            <Modal
                                backdrop={'static'}
                                className="link-to-vendor-modal"
                                show={showLinkToVendorModal}
                                size="xs"
                                overflow={false}
                                onClick={() => { handleClose() }}
                                onHide={() => { handleClose() }}
                            >
                                <Modal.Header>
                                    <Modal.Title className='fw-bold text-black'>
                                        Link Caller Details To Vendor
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className='mt-4 h-75'>
                                    {callsTableData?.length === 0 ? <div className='d-flex justify-content-center'><Loader /></div> : <div>
                                        <label className='h4 text-black'>Select Vendor</label>
                                        <Select
                                            className="list-supplier-options h4 mb-0"
                                            options={callsTableData?.map((option) => {
                                                return {
                                                    label: option?.suppliername,
                                                    value: option?.id
                                                }
                                            })}
                                            value={vendorToLink}
                                            onChange={(vendor) => { onChangeLinkToVendor(vendor) }}
                                        />
                                    </div>}
                                </Modal.Body>
                                <Modal.Footer>
                                    {callsTableData?.length === 0 ? null : <div className='d-flex justify-content-end'>
                                        <button
                                            type="button"
                                            className="me-3 h4 mb-0 pt-2 pb-2 bg-gray text-white width-100 rounded"
                                            onClick={() => handleClose()}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="h4 mb-0 pt-2 pb-2 btn-green width-100 rounded"
                                            onClick={() => handleOkClick()}
                                        >
                                            Ok
                                        </button>
                                    </div>}
                                </Modal.Footer>
                            </Modal>

                            {showLinkToVendorDetailsModal && (
                                <LinkToVendorDetailsModal
                                    vendorInfo={vendorToLink}
                                    callDetails={selectedCallDetail}
                                    show={showLinkToVendorDetailsModal}
                                    onClose={handleVendorDetailsClose}
                                />
                            )}

                            <Modal backdrop={'static'} className={`position-relative${isLoadingUnlinkedCalls ? ' loading' : ''}`} show={showRemoveDetailsConfirmationModal} onHide={handleRemoveCancelClick} onClick={() => { handleRemoveCancelClick() }}>
                                {isLoadingUnlinkedCalls && <LoaderComponent />}
                                <Modal.Header>
                                    <Modal.Title className='fw-bold text-black'>
                                        Remove Caller Details
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className='d-flex flex-column align-items-center'>
                                    <h4 className='mb-0 text-black fw-bold'>Are you sure you want to remove this Call Detail?</h4>
                                    <div className='mt-4'>
                                        <button className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white width-100' onClick={handleRemoveCancelClick}>Cancel</button>
                                        <button className='pt-2 pb-2 h4 mb-0 fw-bold rounded btn-green text-white ms-auto width-100' onClick={handleRemoveOkClick}>Ok</button>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                }
                {activeKey === 'reenablement' &&
                    <div>
                        <div className='d-flex'>
                        </div>
                        <div className={`mt-4 border border-2 rounded position-relative sequence-table`}>
                            <Table
                                virtualized={true}
                                affixHeader={true}
                                height={500}
                                data={reenablementPaginatedData}
                                className='reenablement-table'
                                id='reenablement-table'
                                rowKey="id"
                                sortType={sortType}
                                sortColumn={sortColumn}
                                loading={isLoading}
                                onSortColumn={handleSortColumn}
                            >
                                {headerElements(reenablementTableColumnsWithCaller)}
                                <Column fixed="right" dataKey='call' key="action" width={isAdminOrMod ? 180 : 100}>
                                    <HeaderCell className='fw-bold text-black' align={isAdminOrMod ? 'center' : ''}>Action</HeaderCell>
                                    <CallCell
                                        onClick={handleCallClick}
                                        qaLoader={qaLoader}
                                        callLoader={callLoader}
                                        btnText='Call'
                                        bgClass='bg-green'
                                        customClass='p-5'
                                        isAdminOrMod={isAdminOrMod}
                                        isAdmin={isAdmin}
                                        dispatch={dispatch}
                                        inCallsFilters={inCallsFilters}
                                    />
                                </Column>
                            </Table>

                            <div className="reenablement-table-pagination">
                                <Pagination
                                    prev
                                    next
                                    first={true}
                                    last={true}
                                    maxButtons={5}
                                    activePage={reenablePage}
                                    showInfo
                                    displayLength={reenableLimit}
                                    lengthMenu={[
                                        { label: '10', value: 10 },
                                        { label: '20', value: 20 },
                                        { label: '30', value: 30 },
                                        { label: '50', value: 50 },
                                        { label: '100', value: 100 },
                                    ]}
                                    total={total}
                                    onChangeLength={(limit) => { reenableLimitHandler(limit) }}
                                    onChangePage={(event) => { reenablementPaginationHandler(event) }}
                                />
                            </div>
                        </div>
                    </div>
                }
                {
                    showSendToCallsModal && (
                        <SendToCallsModal
                            show={showSendToCallsModal}
                            handleClose={onSendToCallsModalClose}
                            columns={reenablementTableColumns}
                            isReenablementToCalls={true}
                        />
                    )
                }
            </div>
        </div >
    )
}

export default InSequenceComponent